const AlertIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.04 10.8666L9.92665 2.38663C9.50646 1.72929 8.78014 1.33154 7.99999 1.33154C7.21983 1.33154 6.49351 1.72929 6.07332 2.38663L0.959986 10.8666C0.59235 11.4795 0.579643 12.2419 0.926652 12.8666C1.32797 13.5701 2.07681 14.0031 2.88665 14H13.1133C13.9177 14.0085 14.6652 13.5865 15.0733 12.8933C15.4307 12.2617 15.418 11.4861 15.04 10.8666ZM7.99999 11.3333C7.6318 11.3333 7.33332 11.0348 7.33332 10.6666C7.33332 10.2984 7.6318 9.99996 7.99999 9.99996C8.36818 9.99996 8.66665 10.2984 8.66665 10.6666C8.66665 11.0348 8.36818 11.3333 7.99999 11.3333ZM7.99999 9.33329C8.36818 9.33329 8.66665 9.03482 8.66665 8.66663V5.99996C8.66665 5.63177 8.36818 5.33329 7.99999 5.33329C7.6318 5.33329 7.33332 5.63177 7.33332 5.99996V8.66663C7.33332 9.03482 7.6318 9.33329 7.99999 9.33329Z"
      fill="#FF5630"
    />
  </svg>
);

export default AlertIcon;
